import {ToggleTheme} from './components/toggle-theme';
import {UserInput} from './components/user-input';

new ToggleTheme();
new UserInput();
